import React, { useContext } from "react";
import { IconButton, Tooltip } from "@material-ui/core";
import { Brightness4, Brightness7 } from "@material-ui/icons";
import { ThemeContext } from "util/hooks/ThemeContext";

export default function ThemeToggleButton() {
  const { mode, toggleTheme } = useContext(ThemeContext);

  return (
      <Tooltip
          title={mode === "dark" ? "Cambiar a modo claro" : "Cambiar a modo oscuro"}
          arrow
          placement="bottom"
      >
        <IconButton
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              toggleTheme();
            }}
            color="inherit"
        >
          {mode === "dark" ? <Brightness7 /> : <Brightness4 />}
        </IconButton>
      </Tooltip>
  );
}
